import {
  SchemasScreenContent,
  TopBar,
  AppLayout,
  useGetPayloadSchemasQuery
} from 'prove-common'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'

export const SchemasScreen = () => {
  const {
    data: payloadSchemas,
    isLoading,
    isError,
    isSuccess
  } = useGetPayloadSchemasQuery(null)
  return (
    <AppLayout
      sidebar={<SideBarLayout />}
      isLoading={isLoading}
      isError={isError}
      topBar={<TopBar logo={<AppLogo />} title={'Skjemaer'} />}
    >
      {isSuccess && (
        <SchemasScreenContent
          payloadSchemas={payloadSchemas}
          labId={undefined}
        />
      )}
    </AppLayout>
  )
}
